/** @module csi/breadcrumb/PhaseDropDownButton */
define([
	"dojo/_base/declare",
	"dijit/form/DropDownButton",
	"dijit/MenuItem",
	"csi/_base/underscore",
	"csi/action",
	"csi/locale",
	"csi/reflection",
	"csi/widget/DropDownMenu",
	"csi/xml"
], function(declare,DropDownButton,MenuItem,_,csiAction,locale,reflection,DropDownMenu,xml) {

	return declare(DropDownButton, {
		/** @property {Action} revisionAction - action to select revision */
		revisionAction: null,

		/** @property {csi.view.Widget} view - breadcrumb view */
		view: null,

		/**
		 * Initialize phase drop-down button for phases based on currently displayed master and revision.
		 */
		postCreate: function() {
			var view = this.view;
			var master = view.getViewNode();
			var revision = view.getRevisionNode();
			var revisionAction = this.revisionAction;
			var phases = reflection.getClassConfig(master.$Type).getPhases();
			var phaseRevisions = master[reflection.ATTR_PHASE_REVISIONS];
			var dropDown = new DropDownMenu();

			_.each(phases, function(phaseNode) {
				var phase = phaseNode.$Name;
				var urlPhase = phaseRevisions[phase];
				var bActive = (urlPhase == revision.$URL);

				if (phaseNode.$URL == revision.Phase) {
					this.set("label", locale.getIndexName(phase));
				}

				dropDown.addChild(new MenuItem({
					"class": "csi-menu-item-with-icon",
					disabled: !xml.isValidURL(urlPhase),
					iconClass: bActive ? "csi-checked-menu-item-check" : null,
					label: locale.getIndexName(phase),
					onClick: function() {
						csiAction.invoke(view, view.domNode, revisionAction, {actionValue: urlPhase});
					}
				}));
			}, this);

			this.set("dropDown", dropDown);
			this.inherited(arguments);
		}
	});
});